export default __webpack_public_path__ + "static/media/1-pieces-upper-mantle.e084e68a.svg";